<template>
  <div class="text-editor-component">
    <!-- <ckeditor v-model="textContentComponent" ></ckeditor> -->
    <ckeditor v-model="textContentComponent" :config="editorConfig"></ckeditor>
  </div>
</template>

<script>
export default {
  name: "text-editor-component",
  props: {
    textContent: String,
    height: Number
  },
  computed: {
    textContentComponent: {
      get() {
        return this.textContent;
      },
      set(val) {
        this.$emit("updateContentComponent", val);
      }
    }
  },
  data() {
    return {
      editorConfig: {
        extraPlugins: "font,image,uploadimage,colorbutton,colordialog,pagebreak,print,htmlwriter",
        toolbar: "Bold",
        height: this.height ? this.height : 200,
        allowedContent: true,
        downloadFile: true,
        codeSnippet_theme: "school_book",
        // filebrowserBrowseUrl: '/filemanager_storage?type=Files',
        // filebrowserUploadUrl: '/filemanager_storage/upload?type=Files',
        // filebrowserImageBrowseLinkUrl:
        //   "https://onedrive.live.com/?id=59FFBD6D7046F78D%21105&cid=59FFBD6D7046F78D",
        font_names:
          "Arial/Arial, Helvetica, sans-serif;" +
          "Times New Roman/Times New Roman, Times, serif;" +
          "Verdana",
        codeSnippet_languages: {
          javascript: "JavaScript",
          php: "PHP"
        },
      }
    };
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>